// firebase Setting 표준화 1.0

import { getAnalytics, isSupported } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyDTLv0-PUQXpzeN-BmB5Trp_nXdwWwWY-A',
  authDomain: 'oo-ing.web.app',
  projectId: 'oo-ing',
  storageBucket: 'oo-ing.firebasestorage.app',
  messagingSenderId: '838934236134',
  appId: '1:838934236134:web:e07b68cd17c965a5bd2427',
  measurementId: 'G-XWPJNW7L0E',
}

const app = initializeApp(firebaseConfig)
const auth = getAuth()
const db = getFirestore()
const storage = getStorage()
const rdb = getDatabase()
const functions = getFunctions()
// 실제 Firestore 데이터베이스와 같은 리전(asia-northeast3, 서울)에 배포된 onCall
// 함수(payments/paymentActions.js 등)를 호출하려면 별도 리전으로 초기화한 인스턴스가
// 필요하다 — 기본 functions 인스턴스는 us-central1을 가리켜서 리전이 다른 함수를
// httpsCallable로 호출하면 404가 난다.
const functionsAsia = getFunctions(app, 'asia-northeast3')
const analytics = isSupported().then((yes: boolean) => yes ? getAnalytics(app) : null)

// 로컬 Firebase Emulator Suite 연결 (명시적으로 VITE_USE_FIREBASE_EMULATOR=true 설정 시에만 동작)
// 기본 dev 워크플로우(실제 Firebase 대상)를 건드리지 않기 위해 opt-in 방식으로 처리
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
  try {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
    connectFirestoreEmulator(db, '127.0.0.1', 8080)
    connectFunctionsEmulator(functions, '127.0.0.1', 5001)
    connectFunctionsEmulator(functionsAsia, '127.0.0.1', 5001)
    connectStorageEmulator(storage, '127.0.0.1', 9199)

    console.warn('[firebase] Connected to Local Emulator Suite')
  }
  catch (err) {
    console.error('[firebase] Failed to connect to Local Emulator Suite:', err)
  }
}

export { analytics, app, auth, db, functions, functionsAsia, rdb, storage }
